import { useCallback, useMemo, ComponentType, ReactNode } from "react"
import ListItemDropDownUnstyled from "components/list-item-dropdown"
import type { ListItemDropDownOption } from "components/list-item-dropdown/types"
import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import GraphPanelPeriodControl from "connected-components/graph/components/panel-period-control"
import { ModelMetadata } from "resources/models"
import { buildModelCategoryOptions } from "connected-components/graph/helpers"
import { useCategorySync } from "connected-components/graph/hooks/use-category-sync"
import { useGraphTemplateChart } from "../../hooks/use-graph-template-chart"
import { GRAPH_RISK_TEMPLATE_KEY, GRAPH_CATEGORY_DEFAULTS } from "../template-chart-config"

interface ListItemDropDownProps {
  label: string
  value: string
  setValue: (id: string) => void
  options: ListItemDropDownOption[]
  alignMenu?: "left" | "right"
  disablePortal?: boolean
}

const ListItemDropDown = ListItemDropDownUnstyled as ComponentType<ListItemDropDownProps>

const BASIC_CATEGORY_OPTIONS: ListItemDropDownOption[] = [{ id: "total", primaryText: "Summary" }]

interface RiskHeaderProps {
  modelMetadata: ModelMetadata
  duplicateViewButton?: ReactNode
}

export default function RiskHeader({ modelMetadata, duplicateViewButton }: RiskHeaderProps) {
  const { selectedCategory, setSelectedCategory, isPreferencesLoaded } = useGraphTemplateChart(
    GRAPH_RISK_TEMPLATE_KEY,
    GRAPH_CATEGORY_DEFAULTS,
  )

  const categoryOptions = useMemo<ListItemDropDownOption[]>(
    () => buildModelCategoryOptions(modelMetadata, BASIC_CATEGORY_OPTIONS),
    [modelMetadata],
  )

  useCategorySync(categoryOptions, selectedCategory, setSelectedCategory, isPreferencesLoaded)

  const handleCategoryChange = useCallback((category: string) => {
    setSelectedCategory(category)
  }, [setSelectedCategory])

  return (
    <>
      <GraphTemplateSelector />
      <GraphPanelPeriodControl isPerformance={false} />
      <ListItemDropDown
        label="Category"
        value={selectedCategory}
        setValue={handleCategoryChange}
        options={categoryOptions}
        alignMenu="left"
        disablePortal
      />
      {duplicateViewButton && <div className="graph-header-right">{duplicateViewButton}</div>}
    </>
  )
}
